import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const ViewReportsIcon = ({
  width = '101',
  height = '101',
  className = ''
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-[#F9F9F9] hover:fill-primary-1 ${className ?? ''}`}
    >
      <circle cx="50.0008" cy="50.8951" r="50.0006" />
      <path
        d="M26.1186 32.9593L23.0009 30.9629"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7234 28.0965L31.2566 26.3828"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2036 40.1758L23.4898 40.7032"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.8618 69.5781L68.7234 69.5781L42.2547 69.5781C41.2576 69.5781 40.4493 68.7698 40.4493 67.7728L40.4493 34.0073C40.4493 33.0102 41.2576 32.202 42.2547 32.202L48.2272 32.202L69.8618 32.202C70.9058 32.202 71.7522 33.0483 71.7522 34.0924L71.7522 67.6877C71.7522 68.7318 70.9058 69.5781 69.8618 69.5781Z"
        fill="white"
        stroke="#99999A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.9582 75.4043H63.6838C64.7278 75.4043 65.5742 74.5579 65.5742 73.5139V44.9932C65.5742 44.826 65.5078 44.6658 65.3897 44.5476L59.1289 38.2868C59.0108 38.1687 58.8505 38.1023 58.6834 38.1023H49.5694H37.8731C36.876 38.1023 36.0677 38.9106 36.0677 39.9076V53.2465V73.5139C36.0677 74.5579 36.9141 75.4043 37.9582 75.4043Z"
        fill="white"
        stroke="#99999A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.1025 71.4743V62.6523H43.2058V71.4743H40.1025Z"
        fill="#99999A"
        stroke="#99999A"
        strokeWidth="1.71398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2144 71.4739V58.8711H49.3176V71.4739H46.2144Z"
        fill="#99999A"
        stroke="#99999A"
        strokeWidth="1.71398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.3264 71.4728V54.459H55.4297V71.4728H52.3264Z"
        fill="#99999A"
        stroke="#99999A"
        strokeWidth="1.71398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.4382 71.4729V49.418H61.5415V71.4729H58.4382Z"
        fill="#99999A"
        stroke="#99999A"
        strokeWidth="1.71398"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.3853 35.0996L67.9883 35.0996C68.3363 35.0996 68.6185 35.3817 68.6185 35.7298L68.6185 39.2633"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.7032 35.0996L61.8682 35.0996"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-13-inside-1_3173_73298" fill="white">
        <path d="M45.6065 38.1034C45.6065 43.3716 41.3357 47.6423 36.0675 47.6423C30.7993 47.6423 26.5286 43.3716 26.5286 38.1034C26.5286 32.8352 30.7993 28.5645 36.0675 28.5645C41.3357 28.5645 45.6065 32.8352 45.6065 38.1034Z" />
      </mask>
      <path
        d="M45.6065 38.1034C45.6065 43.3716 41.3357 47.6423 36.0675 47.6423C30.7993 47.6423 26.5286 43.3716 26.5286 38.1034C26.5286 32.8352 30.7993 28.5645 36.0675 28.5645C41.3357 28.5645 45.6065 32.8352 45.6065 38.1034Z"
        fill="#31B59F"
      />
      <path
        d="M44.9362 38.1034C44.9362 43.0014 40.9655 46.9721 36.0675 46.9721V48.3126C41.7059 48.3126 46.2767 43.7418 46.2767 38.1034H44.9362ZM36.0675 46.9721C31.1695 46.9721 27.1988 43.0014 27.1988 38.1034H25.8583C25.8583 43.7418 30.4291 48.3126 36.0675 48.3126V46.9721ZM27.1988 38.1034C27.1988 33.2054 31.1695 29.2347 36.0675 29.2347V27.8942C30.4291 27.8942 25.8583 32.465 25.8583 38.1034H27.1988ZM36.0675 29.2347C40.9655 29.2347 44.9362 33.2054 44.9362 38.1034H46.2767C46.2767 32.465 41.7059 27.8942 36.0675 27.8942V29.2347Z"
        fill="#31B59F"
        mask="url(#path-13-inside-1_3173_73298)"
      />
      <path
        d="M35.8492 43.6334C35.2101 43.6334 34.6014 43.5269 34.0232 43.3138C33.4551 43.1008 32.9783 42.7356 32.5928 42.2182L33.658 41.29C33.8811 41.6349 34.1906 41.9088 34.5862 42.1117C34.992 42.3146 35.413 42.4262 35.8492 42.4465V38.5814C35.4536 38.4799 35.0731 38.348 34.7079 38.1857C34.3427 38.0133 34.0181 37.8053 33.734 37.5618C33.4601 37.3183 33.242 37.0292 33.0797 36.6944C32.9174 36.3495 32.8362 35.9488 32.8362 35.4923C32.8362 35.0662 32.9174 34.6757 33.0797 34.3206C33.242 33.9655 33.4601 33.6612 33.734 33.4076C34.0181 33.1438 34.3427 32.9358 34.7079 32.7837C35.0731 32.6214 35.4536 32.525 35.8492 32.4946V31.4902H36.5796V32.4946C37.1274 32.4946 37.6651 32.596 38.1926 32.7989C38.7303 33.0018 39.1767 33.3112 39.5317 33.7271L38.5274 34.6402C38.2941 34.3358 38.01 34.1025 37.6752 33.9402C37.3405 33.7677 36.9753 33.6815 36.5796 33.6815V37.4705C36.9854 37.6024 37.3811 37.7444 37.7665 37.8966C38.152 38.0488 38.4919 38.2415 38.7861 38.4748C39.0904 38.698 39.3288 38.977 39.5013 39.3118C39.6839 39.6465 39.7752 40.0625 39.7752 40.5596C39.7752 41.0161 39.689 41.4269 39.5165 41.7921C39.344 42.1573 39.1107 42.4718 38.8165 42.7356C38.5325 42.9994 38.1977 43.2073 37.8122 43.3595C37.4267 43.5117 37.0158 43.603 36.5796 43.6334V44.7138H35.8492V43.6334ZM35.8492 33.6815C35.3521 33.7728 34.9514 33.9807 34.6471 34.3054C34.3529 34.6199 34.2058 35.0206 34.2058 35.5075C34.2058 35.7713 34.2464 35.9945 34.3275 36.1771C34.4188 36.3597 34.5355 36.5169 34.6775 36.6488C34.8297 36.7807 35.0021 36.8973 35.1949 36.9988C35.3978 37.0901 35.6159 37.1814 35.8492 37.2727V33.6815ZM36.5796 42.4465C37.097 42.3856 37.5282 42.1878 37.8731 41.853C38.2281 41.5182 38.4057 41.1074 38.4057 40.6204C38.4057 40.3465 38.3549 40.1081 38.2535 39.9052C38.152 39.7023 38.0151 39.5299 37.8426 39.3879C37.6702 39.2458 37.4724 39.1292 37.2492 39.0379C37.0361 38.9364 36.813 38.8502 36.5796 38.7792V42.4465Z"
        fill="white"
      />
    </svg>
  )
}

export default ViewReportsIcon
